export default "__VITE_ASSET__PGoOnYD4__"